import { render, staticRenderFns } from "./YouTubeModal.vue?vue&type=template&id=f5872e7e&scoped=true"
import script from "./YouTubeModal.vue?vue&type=script&lang=js"
export * from "./YouTubeModal.vue?vue&type=script&lang=js"
import style0 from "./YouTubeModal.vue?vue&type=style&index=0&id=f5872e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5872e7e",
  null
  
)

export default component.exports